import React, { useMemo, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

type RequireContext = {
  keys: () => string[];
  <T>(id: string): T;
};

const importAll = (r: RequireContext): string[] => r.keys().map((k) => r<string>(k));

const importedImages: string[] = importAll(
  require.context("../images/gallery", false, /\.(png|jpe?g|webp)$/)
);

const Gallery: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const images = useMemo(() => {
    const arr = [...importedImages];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }, []);

  const slides = useMemo(() => images.map((src) => ({ src })), [images]);

  return (
    <Container className="my-5 text-white">
      <h1 className="mb-0">Gallery</h1>
      <p className="text-white mb-4">A glimpse of our pizzas and moments from past events.</p>

      <Row>
        {images.map((src, i) => (
          <Col md={4} sm={6} xs={12} key={src} className="mb-4">
            <button
              type="button"
              className="tile w-100 p-0 border-0 bg-transparent"
              onClick={() => {
                setIndex(i);
                setOpen(true);
              }}
              aria-label={`Open gallery image ${i + 1}`}
            >
              <img src={src} alt={`Bartollini Pizza ${i + 1}`} loading="lazy" />
              <div className="overlay" />
              <span className="badge-view">View</span>
            </button>
          </Col>
        ))}
      </Row>

      <Lightbox open={open} index={index} close={() => setOpen(false)} slides={slides} />
    </Container>
  );
};

export default Gallery;
